import ApiInterface from "utils/ApiInterface";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

export async function createTeamApi(data) {
  console.log("CREATE TEAM API CALLED: ");
  try {
    const response = await ApiInterface.instance.createTeam(data);
    console.log("response in create teams: ", response);
    return response;
  } catch (error) {
    if (error) {
      console.log("Error in CREATE USER: ", error);
      const { response } = error;
      console.log(response);
      let errorMessage = error?.response?.data?.message;
      if (!!errorMessage) {
        withReactContent(Swal).fire({
          title: "Error",
          html: errorMessage,
        });
      }
    }
  }
}
